enum LineItemStatus {
    UNDECIDED,
    ACCEPTED,
    DECLINED,
}

export default LineItemStatus